import React, { useState } from "react";
import EditIcon from "@mui/icons-material/Edit";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import FormControl from "@mui/material/FormControl";
import FormHelperText from "@mui/material/FormHelperText";
import { TextField } from "@mui/material";
import ValidationProduct from "../validation/validationProduct";
import CustomDropdownStyle from "./style/CustomDropdownStyle";
import Select from "react-select";
import { useFormik } from "formik";
import Swal from "sweetalert2";
import axios from "axios";
import { useEditProduct } from "../hooks/useEditProduct";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import Slide from "@mui/material/Slide";
import "./ButtonEditClient.css";
import "./ButtonEditProduct.css";
import "./ButtonEnableTable.css";
import CustomDropdownEdit from "./style/CustomDropdownEdit";
import handleError from "./utilities/HandleError";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});

const ButtonEditProduct = ({ list, disableBtn }) => {
  const [listUnitMeasure, setListUnitMeasure] = useState([]);
  const [unitMeasure, setUnitMeasure] = useState("");
  const [open, setOpen] = useState(false);
  const [loader, setLoader] = useState(false);

  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));

  const handleOpen = () => {
    getProduct();
    getUnitMeasure();
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
    setUnitMeasure("");
  };
  const handleChangeUnitMeasure = (e) => {
    formikEditProduct.setFieldValue("errorMessage", e.value);
    setUnitMeasure(e.label);
  };

  const getProduct = async () => {
      await axios({
        method: "get",
        url:
          process.env.REACT_APP_API + "/api/v1/billing/product/find/" + list.id,
        headers: {
          Authorization: "Bearer " + localStorage.getItem("accessToken"),
        },
      }).then(data => {
        setUnitMeasure(data.data.nombreUnidadMedida);
        formikEditProduct.setValues({
          codigoProducto: data.data.codigoProducto,
          descripcionProducto: data.data.descripcionProducto,
          errorMessage: data.data.unidadMedida,
          precioUnitario: Number(data.data.precioUnitario).toFixed(2),
        });  
      }).catch( error => {
        handleError(error);
      });
  };

  const getUnitMeasure = async () => {
      const response = await axios({
        method: "get",
        url:
          process.env.REACT_APP_API +
          "/api/v1/billing/parametric/parametricSiatAll",
        params: {
          type: "UNIDAD_DE_MEDIDA",
          pageNumber: 1,
          pageSize: 1000,
          search: "",
        },
        headers: {
          Authorization: "Bearer " + localStorage.getItem("accessToken"),
        },
      }).then( data => {
        setListUnitMeasure(
          data.data.content.map((sup) => ({
            label: sup.descripcion,
            value: sup.codigoClasificador,
          }))
        );
      }).catch( error => {
          handleError(error);
      });
      
    
  };

  const { mutate } = useEditProduct();

  const formikEditProduct = useFormik({
    initialValues: {
      codigoProducto: "",
      descripcionProducto: "",
      precioUnitario: "",
      errorMessage: 0,
    },
    validationSchema: ValidationProduct,
    onSubmit: async (data) => {
      setLoader(true);
      data.id = list.id;
      data.descripcionProducto = data.descripcionProducto.trim();
      data.precioUnitario = parseFloat(data.precioUnitario);
      data.unidadDeMedida = parseInt(data.errorMessage);
      mutate(data, {
        onSuccess: () => {
          handleClose();
          Swal.fire({
            customClass: {
              container: "formEditProduct",
              title: "formTitleEditProduct",
            },
            icon: "success",
            title: "¡La información ha sido actualizada!",
            allowOutsideClick: false,
            allowEscapeKey: false,
          });
          setLoader(false);
        },
        onError: (error) => {
          setLoader(false);
          if (error.response.status === 504) {
            Swal.fire({
              customClass: {
                container: "formEditProduct",
                title: "formTitleEditProduct",
              },
              icon: "error",
              title: "!Lo sentimos!",
              text: "Los servidores de impuestos se encuentran saturados. Por favor, vuelva a intentarlo",
              allowOutsideClick: false,
              allowEscapeKey: false,
            });
          }            
          if (error.response.status === 500 || error.response.status === 503) {
            Swal.fire({
              customClass: {
                container: "formEditProduct",
                title: "formTitleEditProduct",
              },
              icon: "error",
              title: "!Ha ocurrido un error!",
              text: "Por favor vuelva a intentarlo más tarde",
              allowOutsideClick: false,
              allowEscapeKey: false,
            });
          }
          if (error.request.status === 422) {
            Swal.fire({
              customClass: {
                container: "formEditProduct",
                title: "formTitleEditProduct",
              },
              icon: "error",
              title: "!Ha ocurrido un error!",
              text: error.response.data.errors.map(
                (element) => element.message
              ),
              allowOutsideClick: false,
              allowEscapeKey: false,
            });
          }
          if (error.request.status === 404) {
            Swal.fire({
              customClass: {
                container: "formEditProduct",
                title: "formTitleEditProduct",
              },
              icon: "error",
              title: "!Ha ocurrido un error!",
              text: error.response.data.message,
              allowOutsideClick: false,
              allowEscapeKey: false,
            });
          }
          if (
            error.response.status === 400 &&
            error.response.data.message === data.codigoProducto + " in use!"
          ) {
            Swal.fire({
              customClass: {
                container: "formEditProduct",
                title: "formTitleEditProduct",
              },
              icon: "warning",
              title: "!Ha ocurrido un error!",
              text:
                "El producto con el código " +
                data.codigoProducto +
                " ya fue registrado",
              allowOutsideClick: false,
              allowEscapeKey: false,
            });
          }
          if (error.response.status >= 0 && error.response.status <= 99) {
            Swal.fire({
              customClass: {
                container: "formEditProduct",
                title: "formTitleEditProduct",
              },
              icon: "error",
              title: "!Ha ocurrido un problema de conectividad!",
              text: "Por favor vuelva a intentarlo más tarde",
              allowOutsideClick: false,
              allowEscapeKey: false,
            });
          }
        },
      });
    },
  });

  return (
    <>
      {!disableBtn ? (
        <button
          disabled={disableBtn}
          className="buttonEdit"
          type="button"
          onClick={() => handleOpen()}
        >
          <span className="buttonEdit__text">Editar</span>
          <span className="buttonEdit__icon">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="48"
              viewBox="0 0 48 48"
              height="48"
              className="svgEdit"
            >
              <EditIcon sx={{ color: "white" }} />
            </svg>
          </span>
        </button>
      ) : (
        <button
          disabled={disableBtn}
          className="buttonEnableTable"
          type="button"
          onClick={() => handleOpen()}
        >
          <span className="buttonEnableTable__text">Editar</span>
        </button>
      )}
      <Dialog
        fullScreen={fullScreen}
        maxWidth="sm"
        open={open}
        TransitionComponent={Transition}
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle
          sx={{ backgroundColor: "#D1B000", margin: "20px 23px 15px 23px" }}
        >
          <Typography
            className="titleProduct"
            sx={{
              color: "white",
              fontFamily: "Oswald",
              fontSize: "30px",
            }}
          >
            Editar producto o servicio
          </Typography>
        </DialogTitle>
        <DialogContent className="contentDialog">
          <form onSubmit={formikEditProduct.handleSubmit}>
            <Grid container spacing={2}>
              <Grid
                item
                xs={12}
                md={12}
                sx={{ marginTop: "5px", display: "none" }}
              >
                <Typography className="labelFormEditClient">
                  Descripción del producto SIN
                </Typography>
                <TextField
                  readOnly
                  disabled
                  defaultValue={list.descripcionProductoSiat}
                  variant="outlined"
                  size="small"
                  fullWidth
                />
              </Grid>
              <Grid item xs={12} md={6} sx={{ display: "none" }}>
                <Typography className="labelFormEditClient">
                  Código de producto SIN
                </Typography>
                <TextField
                  readOnly
                  disabled
                  defaultValue={list.codigoProductoSiat}
                  variant="outlined"
                  size="small"
                  fullWidth
                />
              </Grid>
              <Grid item xs={12} md={6} sx={{ display: "none" }}>
                <Typography className="labelFormEditClient">
                  Código de actividad CAEB
                </Typography>
                <TextField
                  readOnly
                  disabled
                  defaultValue={list.codigoActividadSiat}
                  variant="outlined"
                  size="small"
                  fullWidth
                />
              </Grid>
              <Grid item xs={12} md={12} sx={{ display: "none" }}>
                <FormControl fullWidth>
                  <Typography className="labelFormEditClient">
                    Código del productoCódigo de actividad CAEB
                  </Typography>
                  <TextField
                    readOnly
                    disabled
                    size="small"
                    fullWidth
                    name="codigoProducto"
                    onBlur={formikEditProduct.handleBlur}
                    onChange={formikEditProduct.handleChange}
                    value={formikEditProduct.values.codigoProducto}
                    variant="outlined"
                    InputProps={{
                      style: {
                        borderRadius: "0px",
                        border: "1px solid white",
                        borderColor: "white",
                      },
                    }}
                  />
                  <FormHelperText sx={{ color: "chocolate", fontSize: "14px" }}>
                    {formikEditProduct.touched.codigoProducto &&
                      formikEditProduct.errors.codigoProducto}
                  </FormHelperText>
                </FormControl>
              </Grid>
              <Grid item xs={12} md={12}>
                <FormControl fullWidth>
                  <Typography className="labelFormEditClient">
                    Nombre del producto
                  </Typography>
                  <TextField
                    size="small"
                    fullWidth
                    name="descripcionProducto"
                    onBlur={formikEditProduct.handleBlur}
                    onChange={formikEditProduct.handleChange}
                    value={formikEditProduct.values.descripcionProducto}
                    variant="outlined"
                    InputProps={{
                      style: {
                        borderRadius: "0px",
                        border: "1px solid white",
                        borderColor: "white",
                      },
                    }}
                  />
                  <FormHelperText sx={{ color: "chocolate", fontSize: "14px" }}>
                    {formikEditProduct.touched.descripcionProducto &&
                      formikEditProduct.errors.descripcionProducto}
                  </FormHelperText>
                </FormControl>
              </Grid>
              <Grid item xs={12} md={12} sx={{ zIndex: 9 }}>
                <Typography className="labelFormEditClient">
                  Seleccione una unidad de medida
                </Typography>
                <Select
                  isSearchable
                  menuPosition="fixed"
                  placeholder=""
                  styles={CustomDropdownEdit}
                  value={listUnitMeasure.filter(
                    (element) => element.label === unitMeasure
                  )}
                  options={listUnitMeasure}
                  onChange={(e) => {
                    handleChangeUnitMeasure(e);
                  }}
                />
              </Grid>
              <FormControl fullWidth>
                <TextField
                  sx={{ display: "none" }}
                  variant="outlined"
                  size="small"
                  fullWidth
                  name="errorMessage"
                  onBlur={formikEditProduct.handleBlur}
                  onChange={formikEditProduct.handleChange}
                  value={formikEditProduct.values.errorMessage}
                />
                <FormHelperText
                  sx={{
                    color: "chocolate",
                    fontSize: "14px",
                    marginLeft: "30px",
                  }}
                >
                  {formikEditProduct.values.errorMessage === 0 &&
                    formikEditProduct.touched.errorMessage &&
                    formikEditProduct.errors.errorMessage}
                </FormHelperText>
              </FormControl>
              <Grid item xs={12} md={12}>
                <FormControl fullWidth>
                  <Typography className="labelFormEditClient">
                    Precio unitario
                  </Typography>
                  <TextField
                    size="small"
                    fullWidth
                    name="precioUnitario"
                    onBlur={formikEditProduct.handleBlur}
                    onChange={formikEditProduct.handleChange}
                    value={formikEditProduct.values.precioUnitario}
                    variant="outlined"
                    InputProps={{
                      style: {
                        borderRadius: "0px",
                        border: "1px solid white",
                        borderColor: "white",
                      },
                    }}
                  />
                  <FormHelperText sx={{ color: "chocolate", fontSize: "14px" }}>
                    {formikEditProduct.touched.precioUnitario &&
                      formikEditProduct.errors.precioUnitario}
                  </FormHelperText>
                </FormControl>
              </Grid>
            </Grid>
            <Box
              sx={{
                display: "flex",
                justifyContent: "flex-end",
                marginTop: "20px",
                marginBottom: "10px",
              }}
            >
              <button
                className="buttonCloseX"
                type="button"
                onClick={() => handleClose()}
                style={{ marginRight: "10px" }}
              >
                <span className="buttonCloseX__text">Cerrar</span>
              </button>
              {loader ? (
                <button
                  className="buttonLoaderChangePOV"
                  style={{ width: "150px", height: "40px" }}
                >
                  <div className="loader">
                    <div className="bar1"></div>
                    <div className="bar2"></div>
                    <div className="bar3"></div>
                    <div className="bar4"></div>
                    <div className="bar5"></div>
                    <div className="bar6"></div>
                    <div className="bar7"></div>
                    <div className="bar8"></div>
                    <div className="bar9"></div>
                    <div className="bar10"></div>
                    <div className="bar11"></div>
                    <div className="bar12"></div>
                  </div>
                </button>
              ) : (
                <button
                  className="buttonRegisterData"
                  style={{ border: "1px solid #D1B000" }}
                  type="submit"
                >
                  <span className="buttonEdit">Actualizar</span>
                </button>
              )}
            </Box>
          </form>
        </DialogContent>
      </Dialog>
    </>
  );
};
export default ButtonEditProduct;
